// extracted by mini-css-extract-plugin
export default {"gradText":"GradientText_gradText__yUlTC","shimmer":"GradientText_shimmer__V4G8t"};